import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { config } from "../config";

// Define a service using a base URL and expected endpoints
export const headerApi = createApi({
  reducerPath: "headerApi",
  baseQuery: fetchBaseQuery({
    baseUrl: config.base_url,
    prepareHeaders: (headers, { getState }) => {
      const token = localStorage.getItem("token");
      headers.set("Access-Control-Allow-Origin", "*");
      headers.set("Authorization", "Bearer " + token);
      return headers;
    },
  }),
  // global configuration for the api
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    addHeader: builder.mutation({
      query: (header) => {
        return {
          url: "/add-heading",
          method: "post",
          body: header,
        };
      },
    }),
    updateHeader: builder.mutation({
      query: (header) => {
        return {
          url: "/update-heading",
          method: "post",
          body: header,
        };
      },
    }),
    deleteHeader: builder.mutation({
      query: (headerId) => {
        console.log("headerApi ::", {
          url: "/delete-heading/" + headerId,
          method: "post",
        });
        return {
          url: "/delete-heading/" + headerId,
          method: "get",
        };
      },
    }),
    addHeaderPost: builder.mutation({
      query: (data) => {
        return {
          url: "/add-header-post",
          method: "post",
          body: data,
        };
      },
    }),
    removeHeaderPost: builder.mutation({
      query: (data) => {
        return {
          url: "/delete-header-post",
          method: "post",
          body: data,
        };
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useAddHeaderMutation, useUpdateHeaderMutation, useDeleteHeaderMutation, useAddHeaderPostMutation, useRemoveHeaderPostMutation } = headerApi;
